import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "goalForm", "goalFormToggle",
    "itemForm", "itemFormToggle",
    "qrForm", "qrChangeButton",
    "contributeForm", "contributeButton",
    "contributionCaret",
    "noTargetCheckbox", "targetAmountField"
  ]

  // Sync each goal form (new and edit forms, including ones swapped in by
  // Turbo Streams) so it opens with the target field in the right state.
  noTargetCheckboxTargetConnected(checkbox) {
    this.syncTargetAmount(checkbox)
  }

  // "No target amount" checkbox on the goal form
  toggleNoTarget(event) {
    this.syncTargetAmount(event.currentTarget)
  }

  // Disable and clear the target field of the checkbox's own form when the
  // goal has no target; enable and require it otherwise. Several goal forms
  // share this controller, so the pair is matched by form.
  syncTargetAmount(checkbox) {
    const form = checkbox.closest("form")
    const field = this.targetAmountFieldTargets.find(el => el.closest("form") === form)
    if (!field) return

    if (checkbox.checked) {
      field.value = ""
      field.disabled = true
      field.required = false
    } else {
      field.disabled = false
      field.required = true
    }
  }

  // Toggle the new goal form
  toggleGoalForm() {
    if (this.hasGoalFormTarget) {
      this.goalFormTarget.classList.toggle("hidden")
    }
  }

  // Toggle the new item form
  toggleItemForm() {
    if (this.hasItemFormTarget) {
      this.itemFormTarget.classList.toggle("hidden")
    }
  }

  // Toggle QR change form
  toggleQrForm() {
    if (this.hasQrFormTarget) {
      this.qrFormTarget.classList.toggle("hidden")
    }
  }

  // Toggle edit goal form
  toggleEditGoal(event) {
    const goalId = event.currentTarget.dataset.goalId
    const editForm = document.getElementById(`edit-goal-${goalId}`)
    if (editForm) {
      editForm.classList.toggle("hidden")
    }
  }

  // Toggle edit item form
  toggleEditItem(event) {
    const itemId = event.currentTarget.dataset.itemId
    const editForm = document.getElementById(`edit-item-${itemId}`)
    if (editForm) {
      editForm.classList.toggle("hidden")
    }
  }

  // Toggle contributions accordion
  toggleContributions(event) {
    const goalId = event.currentTarget.dataset.goalId
    const contributionsList = document.getElementById(`contributions-${goalId}`)
    if (contributionsList) {
      contributionsList.classList.toggle("hidden")
    }

    // Rotate caret
    const caret = this.contributionCaretTargets.find(
      el => el.dataset.goalId === goalId
    )
    if (caret) {
      caret.classList.toggle("rotate-90")
    }
  }

  // Toggle contribute form (public view)
  toggleContributeForm() {
    if (this.hasContributeFormTarget) {
      this.contributeFormTarget.classList.toggle("hidden")
    }
    if (this.hasContributeButtonTarget) {
      this.contributeButtonTarget.classList.toggle("hidden")
    }
  }
}
